import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	ActionHistoryButton,
	ApproveCancellationButton,
	CFIInformationPanel,
	ExitButton,
	PrintButton,
	PurchaseOrderDatesPanel,
	PurchaseOrderFilesButton,
	PurchaseOrderInformationPanel,
	PurchaseOrderNotes,
	PurchaseOrderPage,
	PurchaseOrderProducts,
	PurchaseOrderProgress,
	RejectCancellationButton,
	RetailOrderInformationPanel
} from '../../../features/distributor/purchase-order';
import '../../../css/order.scss';
import { useAuth } from '../../../contexts/auth';
import { CompanyTypes } from '../../../types/enums';

export default function PurchaseOrderInfoPage() {

	const { user } = useAuth();
	const isServiceProvider = user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER;

	return (

		<PurchaseOrderPage>

			<PurchaseOrderProgress />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<ApproveCancellationButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<RejectCancellationButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PrintButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ActionHistoryButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PurchaseOrderFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
			</Toolbar>
			<Box>
				<Item ratio={1}>
					<PurchaseOrderInformationPanel />
				</Item>
				<Item ratio={1}>
					<CFIInformationPanel />
				</Item>
				<Item ratio={1}>
					{
						isServiceProvider ?
							<RetailOrderInformationPanel />
							:
							<PurchaseOrderDatesPanel />
					}
				</Item>
			</Box>

			<PurchaseOrderProducts />

			<PurchaseOrderNotes />

		</PurchaseOrderPage>
	)
}
